// ================================================================================
// wp-block-location-finder.js
// スライダーのスクリプトファイル
// ================================================================================

document.addEventListener('DOMContentLoaded', function() {
	var root = document.querySelector('.js-location-finder');
	if (!root) return;

	var storeData = readStoreData(root);
	if (!storeData.length) return;

	var resultsIndexEl = root.querySelector('.js-location-finder-list');
	if (!resultsIndexEl) return;

	var storeSelectEl = root.querySelector('.js-location-finder-select');

	var allDataHtml = resultsIndexEl.innerHTML;

	var defaultCenter = { lat: 35.906487, lng: 139.628754 };
	var defaultZoom = 12;

	var mapAreaEl = document.getElementById('js-location-finder-map');
	var iconMarkerUrl = '/wp-content/themes/toyota-rlss/assets/images/icon_store_place.png';
	var iconListUrl = '/wp-content/themes/toyota-rlss/assets/images/ico_location.png';

	var currentWindow = null;

	numberCards(resultsIndexEl);

	waitForGoogleMaps(function() {
		initialize(buildMapPayload(storeData), 'initial');
	});

	if (storeSelectEl) {
		storeSelectEl.addEventListener('change', function() {
			var val = storeSelectEl.value;

			if (val !== '') {
				var filterData = storeData.filter(function(elem) {
					return String(elem.term) === String(val);
				});

				updateHeadline(storeSelectEl);

				resultsIndexEl.innerHTML = buildListHtml(filterData, iconListUrl);
				numberCards(resultsIndexEl);

				currentWindow = null;
				waitForGoogleMaps(function() {
					initialize(buildMapPayload(filterData), 'update');
				});

				return;
			}

			// reset
			resultsIndexEl.innerHTML = allDataHtml;
			numberCards(resultsIndexEl);

			currentWindow = null;
			waitForGoogleMaps(function() {
				initialize(buildMapPayload(storeData), 'initial');
			});
		});
	}

	function readStoreData(rootEl) {
		var dataEl = rootEl.querySelector('.js-location-finder-data');
		if (!dataEl) return [];

		try {
			var json = JSON.parse(dataEl.textContent || '[]');
			return Array.isArray(json) ? json : [];
		} catch (e) {
			return [];
		}
	}

	function numberCards(containerEl) {
		containerEl.querySelectorAll('.js-location-finder-item').forEach(function(card, i) {
			var numEl = card.querySelector('.js-location-finder-item__number');
			if (numEl) numEl.textContent = String(i + 1);
		});
	}

	function updateHeadline(selectEl) {
		var headlineEl = document.querySelector('.js-headlinePlain');
		if (!headlineEl) return;

		var opt = selectEl.options[selectEl.selectedIndex];
		var text = opt ? opt.text : '';
		headlineEl.textContent = text + 'の店舗一覧';
	}

	function isMobileUa() {
		var ua = navigator.userAgent || '';
		return (
			(ua.indexOf('Android') > -1 && ua.indexOf('Mobile') > -1) ||
			ua.indexOf('iPod') > -1 ||
			(ua.indexOf('iPhone') > -1 && ua.indexOf('iPad') === -1)
		);
	}

	function escapeHtml(str) {
		return String(str == null ? '' : str)
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;')
			.replace(/'/g, '&#039;');
	}

	function buildListHtml(list, iconUrl) {
		var html = '';
		var isMobile = isMobileUa();

		for (var i = 0; i < list.length; i++) {
			html += buildCardHtml(list[i], i + 1, isMobile, iconUrl);
		}

		return html;
	}

	function buildCardHtml(item, num, isMobile, iconUrl) {
		var title = escapeHtml(item.title);
		var zip = escapeHtml(item.zip);
		var address = escapeHtml(item.address);
		var phone = escapeHtml(item.phone);
		var id = escapeHtml(item.id);
		var hours = escapeHtml(item.hours);
		var holiday = escapeHtml(item.holiday);

		var fullAddress = '〒' + zip + ' ' + address;

		return (
			'<div class="wp-block-location-finder-item js-location-finder-item">' +
				'<div class="wp-block-location-finder-item__header">' +
					'<div class="wp-block-location-finder-item__num">' +
						'<div class="wp-block-location-finder-item__numText js-location-finder-item__number"></div>' +
					'</div>' +
					'<div class="wp-block-location-finder-item__header-title">' +
						'<div class="wp-block-location-finder-item__sub-title">トヨタレンタカー</div>' +
						'<div class="wp-block-location-finder-item__title">' +
							'<a href="/location/' + id + '">' +
								'<span>' +
									title +
								'</span>' +
							'</a>' +
						'</div>' +
					'</div>' +
				'</div>' +
				'<div class="wp-block-location-finder-item__details">' +
					'<div class="wp-block-location-finder-item__details-item">' +
						'<div class="wp-block-location-finder-item-detail is-address">' +
							'<div class="wp-block-location-finder-item-detail__title">' +
								'住所' +
							'</div>' +
							'<div class="wp-block-location-finder-item-detail__description">' +
								'〒' + zip + '<br>' + address +
								'<br>' +
								'<span class="wp-block-location-finder-item-detail__description-tel">' +
									'電話番号：' + phone +
								'</span>' +
							'</div>' +
						'</div>' +
					'</div>' +
					'<div class="wp-block-location-finder-item__details-item">' +
						'<div class="wp-block-location-finder-item-detail">' +
							'<div class="wp-block-location-finder-item-detail__title">' +
								'営業時間' +
							'</div>' +
							'<div class="wp-block-location-finder-item-detail__description">' +
								hours +
							'</div>' +
						'</div>' +
						'<div class="wp-block-location-finder-item-detail">' +
							'<div class="wp-block-location-finder-item-detail__title">' +
								'休業日' +
							'</div>' +
							'<div class="wp-block-location-finder-item-detail__description">' +
								holiday +
							'</div>' +
						'</div>' +
					'</div>' +
				'</div>' +
				'<div class="wp-block-location-finder-item__buttons">' +
					'<a href="tel:' + phone + '" class="wp-block-location-finder-item__button">' +
						'<span>' +
							phone +
						'</span>' +
					'</a>' +
				'</div>' +
			'</div>'
		);
	}

	function buildMapPayload(data) {
		var payload = {
			num: data.length,
			title: [],
			lat: [],
			lng: [],
			zipcode: [],
			address: [],
			phone: [],
			id: []
		};

		for (var i = 0; i < data.length; i++) {
			payload.title[i] = data[i].title;
			payload.lat[i] = data[i].lat;
			payload.lng[i] = data[i].lng;
			payload.zipcode[i] = data[i].zip;
			payload.address[i] = data[i].address;
			payload.phone[i] = data[i].phone;
			payload.id[i] = data[i].id;
		}

		return payload;
	}

	function toLatLngLiteral(lat, lng) {
		var latNum = parseFloat(lat);
		var lngNum = parseFloat(lng);
		if (Number.isNaN(latNum) || Number.isNaN(lngNum)) return null;
		return { lat: latNum, lng: lngNum };
	}

	function canUseGoogleMaps() {
		return !!(window.google && google.maps && google.maps.Map);
	}

	function waitForGoogleMaps(callback) {
		var limit = 200;
		var count = 0;

		function tick() {
			if (canUseGoogleMaps()) {
				callback();
				return;
			}
			count++;
			if (count >= limit) return;
			setTimeout(tick, 50);
		}

		tick();
	}

	function createMarker(name, latlng, icons, number, map, zipcode, address, phone, id) {
		var fullAddress = '〒' + escapeHtml(zipcode) + ' ' + escapeHtml(address);
		var contentString =
			'<div class="p-storeSearchItem" id="content">' +
				'<h2 class="p-storeSearchItem__title">' + escapeHtml(name) + '</h2>' +
				'<div class="storeSearchItem__body">' +
					'<p>' + fullAddress + '</p>' +
					'<p>TEL. ' + escapeHtml(phone) + '</p>' +
					'<p><a href="/location/' + escapeHtml(id) + '">店舗情報はこちら</a></p>' +
				'</div>' +
			'</div>';

		var infoWindow = new google.maps.InfoWindow();

		var marker = new google.maps.Marker({
			position: latlng,
			map: map,
			icon: icons,
			label: {
				text: number,
				color: '#fff',
			}
		});

		google.maps.event.addListener(marker, 'click', function() {
			if (currentWindow) currentWindow.close();
			infoWindow.setContent(contentString);
			infoWindow.open(map, marker);
			currentWindow = infoWindow;
		});
	}

	function initialize(payload, mode) {
		if (!canUseGoogleMaps()) return;
		if (!mapAreaEl) return;

		var map = new google.maps.Map(mapAreaEl, {
			zoom: defaultZoom,
			center: defaultCenter,
			mapTypeId: 'roadmap'
		});

		var bounds = new google.maps.LatLngBounds();
		var icons = {
			url: iconMarkerUrl,
			size: new google.maps.Size(26, 44),
			origin: new google.maps.Point(0, -4),
		};

		var validCount = 0;

		for (var i = 0; i < payload.num; i++) {
			var latlng = toLatLngLiteral(payload.lat[i], payload.lng[i]);
			if (!latlng) continue;

			validCount++;

			createMarker(
				payload.title[i],
				latlng,
				icons,
				String(i + 1),
				map,
				payload.zipcode[i],
				payload.address[i],
				payload.phone[i],
				payload.id[i]
			);

			bounds.extend(latlng);
		}

		if (mode === 'initial') return;
		if (!validCount) return;

		if (validCount === 1) {
			map.setCenter(bounds.getCenter());
			map.setZoom(14);
			return;
		}

		map.fitBounds(bounds);
	}
});


// 「路線から探す」のアコーディオン
// --------------------------------------------------------------- //
document.addEventListener('DOMContentLoaded', function () {
	document.addEventListener('click', e => {
		const btn = e.target.closest('.js-cn-route-toggle');
		if (!btn) return;

		const parent = btn.closest('.p-cn-route');
		const el = parent.querySelector('.p-cn-route__container');

		const isOpen = el.classList.toggle('is-open');
		parent.classList.toggle('is-active');

		el.style.height = isOpen ? el.scrollHeight + 'px' : '0px';
	});
});